<template>
    <div>
        <h4 class="title is-4">
            Two-Factor Authentication
        </h4>

        <h5 class="subtitle is-6">
            Enter the 6 digit code from your two-factor authentication app.
        </h5>

        <form
            @submit.prevent="submit"
            autocomplete="off"
        >
            <FormNotification />

            <SavingNotification>
                Sending...
            </SavingNotification>

            <b-field label="Code">
                <b-input
                    v-model="OneTimePassword"
                    v-validate="{ required: true, length: 6 }"
                    type="number"
                    name="OneTimePassword"
                    data-vv-as="Code"
                    autocomplete="off"
                />
            </b-field>

            <b-button
                type="is-info"
                tag="button"
                :disabled="isSendingOrSuccess"
                native-type="submit"
            >
                Verify
            </b-button>
        </form>
    </div>
</template>

<script>
import Form from '../mixins/form.js';
import { mapFields } from "vuex-map-fields";

export default {
    mixins: [
        Form,
    ],

    computed: {
        ...mapFields('twoFactorAuthentication', [
            'OneTimePassword',
        ]),
    },

    methods: {
        submit() {
            this.isSuccess = null;

            this.validate()
            .then((result) => {
                if (! result) {
                    return;
                }

                this.$store.dispatch('twoFactorAuthentication/verify')
                .then(() => {
                    this.statusType = 'success';
                    this.isSuccess = true;
                    this.isSending = false;

                    // redirect to dashboard
                    window.location.href = '/';
                })
                .catch((error) => {
                    this.statusType = 'error';
                    this.statusMessage = error.response.data.message[0];
                    this.isSuccess = false;
                    this.isSending = false;
                });
            });
        },
    },
};
</script>
